import Box from '@mui/material/Box'

const getStatusColor = (status) => {
  switch (status) {
    case 'running':
      return 'success.main'
    case 'stopped':
    case 'exited':
    case 'dead':
      return 'error.main'
    case 'restarting':
    case 'paused':
      return 'warning.main'
    default:
      return 'grey.400'
  }
}

export const hasKnownStatus = (service) => {
  return service.currentStatuses && service.currentStatuses.length > 0
}

const getServiceStatus = (service) => {
  if (hasKnownStatus(service)) {
    return service.currentStatuses[0].state
  }
  return 'unknown'
}

function ServiceStatusIndicator({ service, pendingTask }) {
  const status = getServiceStatus(service)
  const isTransitioning = Boolean(pendingTask)

  return (
    <Box
      sx={{
        width: '2rem',
        height: '2rem',
        borderRadius: '50%',
        bgcolor: getStatusColor(status),
        ...(isTransitioning && {
          animation: 'pulse 1.5s ease-in-out infinite',
          '@keyframes pulse': {
            '0%': { opacity: 1, transform: 'scale(1)' },
            '50%': { opacity: 0.5, transform: 'scale(0.9)' },
            '100%': { opacity: 1, transform: 'scale(1)' },
          },
        }),
      }}
    />
  )
}

export default ServiceStatusIndicator
